import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { ArrowLeft, Save } from 'lucide-react';
import { PromotionForm } from './components/PromotionForm';
import { PromotionFormData } from './types';
import { usePromotions } from './hooks/usePromotions';

export const CreatePromotionPage: React.FC = () => {
  const navigate = useNavigate();
  const { createPromotion } = usePromotions();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data: PromotionFormData) => {
    try {
      setLoading(true);
      await createPromotion(data);
      navigate('/promotions', {
        replace: true,
        state: { message: 'Promoción creada exitosamente' }
      });
    } catch (error) {
      console.error('Error creating promotion:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/promotions');
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleCancel}
            className="text-gray-600 hover:text-gray-900"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Volver
          </Button>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Nueva Promoción</h1>
            <p className="text-gray-600 mt-1">Crea una nueva promoción o descuento especial</p>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Save className="w-5 h-5" />
            Información de la Promoción
          </CardTitle>
        </CardHeader>
        <CardContent>
          <PromotionForm
            promotion={null}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
            loading={loading}
          />
        </CardContent>
      </Card>
    </div>
  );
};